// English resources for the public landing page (namespace "landing").
// Keep keys in sync with ../pl/landing.ts.
//
// 2026-09-19: Domi restored the earlier three-edit composition.
//
// 2026-09-20, round 37-R3 (the public page as a road to action): an eyebrow names the
// audience above the headline.
//
// 2026-09-23, package HD: the owner chose hero D ("D is the best", 22.09), so the A / B call
// is closed: `hero.title`, `hero.titleA` and `hero.lead` are gone, and the headline, the
// sentence under it and the words of the "metro map" are the MAPA D keys (`titleD`, `leadD`,
// `how`, `map.*`, `mapAlt`). The second picture ("One series. All your accounts.") went with
// `accountsMap.*`: the hero carries the same story on the first screen.
//
// The credibility pass (P06) still applies: every number on the page is true and comes
// from `/api/billing/plans` (`gem_costs.render`, `gem_costs.publish`, the Starter price)
// or from `lib/startBonus.ts`, i.e. from the catalogue in `app/billing/costs.py`. One
// footer, one set of keys: `footer.*` serves the landing, pricing, FAQ, legal pages and
// the guest 404.
export const landing = {
  nav: {
    funkcje: 'Features',
    jak: 'How it works',
    cennik: 'Pricing',
    faq: 'FAQ',
    toPanel: 'Go to edits',
    login: 'Sign in',
    startFree: 'Start free',
  },
  hero: {
    // Who the page is for, above the headline (artboard 01).
    eyebrow: 'For music artists',
    // Hero D (MAPA D): two sentences, each its own block of the H1.
    titleD: 'A miracle has no date.\nYour posts do.',
    leadD: 'One track becomes a series of edits for your accounts. You set the days and hours.',
    ctaStart: 'Start free',
    ctaPricing: 'See pricing',
    // {n} = the signup bonus divided by the price of an edit (lib/startBonus.ts,
    // read from app/). The unit is interpolated so the count can govern the noun.
    micro: 'No card · {n} free {edits}',
    // Quiet link next to the micro line: an anchor to the three steps.
    how: 'See how it works',
    // Words inside the map; accounts, hours and frames are data (`landingFlowMap.data.ts`).
    map: {
      track: 'Night Drive',
      // {n} = the number of edits in the sample series, unit inflected (`editWord`).
      series: '{n} {edits}',
      today: 'today',
      days: 'Mon · Tue · Wed · Thu · Fri · Sat · Sun',
    },
    // The map is ONE image for a screen reader, with this description (MAPA D, copy).
    mapAlt: 'One track becomes a series of nine edits. They go to your three accounts: TikTok, Instagram and YouTube. Each post has the day and hour you set; two are already out, one is waiting for your approval, the rest are scheduled.',
  },
  showcase: {
    title: 'Sample edits',
    playExample: 'Play sample edit {n}',
    ownClips: 'Your clips',
    packs: 'Clip packs',
    hooks: 'Opening hook',
    variants: 'Different styles',
    error: 'This sample could not be played. Choose another edit.',
    retry: 'Try again',
    // Edit caption and track title on the three-phone mock-up (decoration, `aria-hidden`).
    // The centre one is the same song as `hero.map.track`. Account handles are proper names.
    examples: {
      left: { lyric: 'one more time', track: 'Stop in the Fog' },
      center: { lyric: 'night drive', track: 'Night Drive' },
      right: { lyric: 'stay a while', track: 'Green Crossing' },
    },
  },
  how: {
    heading: 'Three steps. Zero editing.',
    note: 'Nothing goes out without your approval.',
    // No sentences under the steps (rule 8, MAPA 37): the wordless visual says it,
    // and `note` closes the whole section.
    step1Title: 'Upload a track',
    step2Title: 'Choose edits from the series',
    step3Title: 'Approve the schedule',
  },
  price: {
    heading: 'What it costs',
    // Rule 8: the two-sentence paragraph about paying is down to ONE fact.
    refund: 'A failed render costs nothing.',
    // The money line: the cheapest plan in the `/api/billing/plans` catalogue, the
    // same one Pricing counts from. Without an answer the line is not drawn.
    from: 'Plans from {price} / mo.',
    oneEdit: '1 edit',
    onePublish: '1 post',
    link: 'See plans and prices in Pricing',
  },
  // The closing section: the same dark stage as the first screen, one action and a row
  // of facts, every one of which can be checked on this same page.
  closing: {
    heading: 'Your first series is free.',
    fact1: 'No card to start',
    fact2: 'Only your account sees your files',
    fact3: "You connect accounts with the platform's official login",
    fact4: 'Payments are handled by Stripe',
    fact5: 'Cancel anytime',
  },
  footer: {
    // Three groups (R3): Product / Help / Legal, on EVERY public page. The tagline,
    // the "Account" column and the copyright bar are gone.
    groupProduct: 'Product',
    groupHelp: 'Help',
    groupLegal: 'Legal',
    product: 'Product',
    funkcje: 'Features',
    jak: 'How it works',
    cennik: 'Pricing',
    faq: 'FAQ',
    login: 'Sign in',
    contact: 'Contact',
    terms: 'Terms',
    refunds: 'Refunds & cancellation',
    // The one-line paczka 37 footer used a shorter label; the "Help" group has room
    // for the document's full name.
    refundsShort: 'Refunds',
    // The short label for the legal strip under the sign-in and sign-up card (04a–06d):
    // it stands next to "Terms" and "Report content", where the full name breaks the row.
    privacyShort: 'Privacy',
    // The full name of the document: in a "Legal" group, "Privacy" does not name the
    // file a person signs up under.
    privacyFull: 'Privacy Policy',
    seller: 'JDG Dominik Łupicki',
    report: 'Report content',
    copyright: '© 2026 EDIMI · edimi.ai',
    version: 'Publishing through the official TikTok, Instagram and YouTube APIs',
  },
}
